import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { useDisableScroll } from 'hooks'

import { modalsV2 } from 'store/slices/modals'
import { useCurrentUser } from 'store/api/yay/user'
import { VerifyEmailForm } from 'features/UserSetting/components'

const OTPModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const modalState = useSelector((state) => state.modalsV2['OTPModal'])

  const { data: currentUser } = useCurrentUser()

  useDisableScroll(Boolean(modalState?.isActive))

  if (!modalState || !modalState?.isActive) return null

  const onClose = () => {
    if (modalState?.data?.forceFlow) {
      // should go back on close
      navigate(-1)
    } else {
      dispatch(modalsV2.actions.closeModal({ id: 'OTPModal' }))
    }
  }

  const onNext = () => {
    modalState?.data?.onVerify()
  }

  return (
    <div
      className={cx('Modal OTPModal', {
        'Modal--active': modalState?.isActive,
      })}
    >
      <a className="Modal__overlay" onClick={() => onClose()} />
      {modalState?.isActive && (
        <div className="Modal__wrapper Modal__wrapper--auto-h">
          <div className="Modal__header">
            {t('confirm_email.confirm_email_address')}
          </div>
          <div className="Modal__body">
            <img src="/images/paper-plane.png" />
            <VerifyEmailForm
              email={currentUser?.email}
              mode="otp"
              onNext={() => {
                onNext()
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default OTPModal
